import { render } from "./uiButton.vue?vue&type=template&id=29a98294&scoped=true"
import script from "./uiButton.vue?vue&type=script&lang=js"
export * from "./uiButton.vue?vue&type=script&lang=js"

import "./uiButton.vue?vue&type=style&index=0&id=29a98294&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a98294"]])

export default __exports__